export const paymentModeDeclaration =
  'In case of online payment mode, I/We understand that funds shall be held in collections account pending onboarding and shall not be invested until satisfactory completion of all regulatory and documentation requirements.';
